import models.GameRepository
import org.koin.dsl.module

val appModule = module {
    single {
        GameRepository(
            localDataSource = LocalGameDataSource(),
            remoteDataSource = RemoteGameDataSource()
        )
    }
}

